import { CircularProgress, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.colors.greyE8,
  },
}));

function LoadingIndicator() {
  const classes = useStyles();
  return <CircularProgress size={16} thickness={5} className={classes.root} />;
}

export default LoadingIndicator;
